import { useLayoutEffect, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Typography, useMediaQuery } from '@mui/material';

// project-imports
import NavGroup from './NavGroup';
import menuItem, { menuItemsDefault } from 'menu-items';
//@ts-ignore
import { Menu } from 'menu-items/dashboard';

import { useSelector } from 'store';
import useConfig from 'hooks/useConfig';
import { HORIZONTAL_MAX_ITEM } from 'config';

// types
import { NavItemType } from 'types/menu';
import { MenuOrientation } from 'types/config';
import { useDataContext } from 'contexts/DataContext';
import { useFirebaseContext } from 'contexts/FirebaseContext';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const Navigation = () => {
  const theme = useTheme();

  const downLG = useMediaQuery(theme.breakpoints.down('lg'));

  const { menuOrientation } = useConfig();
  const { drawerOpen } = useSelector((state) => state.menu);

  const [selectedItems, setSelectedItems] = useState<string | undefined>('');
  const [selectedLevel, setSelectedLevel] = useState<number>(0);
  const [menuItems, setMenuItems] = useState<{ items: NavItemType[] }>({ items: [] });
  const { isAdvanced } = useDataContext();
  const { user } = useFirebaseContext();
  const permissions = user?.permissions;

  //   useLayoutEffect(() => {
  //     const menuItemsToDisplay = isAdvanced ? menuItem : menuItemsDefault;

  //     const filterMenuItems = (): NavItemType[] => {
  //       return (
  //         menuItemsToDisplay.items?.map((parentMenu) => ({
  //           ...parentMenu,
  //           children: parentMenu.children?.filter((childMenu) => childMenu.id !== 'employees')
  //         })) || []
  //       );
  //     };

  //     if (user?.userType === 'ADMIN') {
  //       setMenuItems(menuItemsToDisplay || { items: [] });
  //     } else {
  //       setMenuItems({ items: filterMenuItems() });
  //     }
  //   }, [menuItem, isAdvanced, user]);
  useLayoutEffect(() => {
    const menuItemsToDisplay = isAdvanced ? menuItem : menuItemsDefault;

    const filterMenuItems = (): NavItemType[] => {
      return (
        menuItemsToDisplay.items
          ?.map((parentMenu) => ({
            ...parentMenu,
            children: parentMenu.children?.filter((childMenu) => {
              if (!permissions?.includes('canViewUsers') && childMenu.id === 'users') {
                return false;
              }
              if (user?.userType !== 'ADMIN' && childMenu.id === 'employees') {
                return false;
              }
              if (!permissions?.includes('canViewBacktests') && childMenu.id === 'list-simulations') {
                return false;
              }
              if (!permissions?.includes('canViewLiveTrade') && childMenu.id === 'live-simulations') {
                return false;
              }
              if (!permissions?.includes('canViewConfig') && childMenu.id === 'configs') {
                return false;
              }
              if (!permissions?.includes('canViewMarketHolidays') && childMenu.id === 'market-holidays') {
                return false;
              }
              if (!permissions?.includes('canViewAppSettings') && childMenu.id === 'app-settings') {
                return false;
              }
              if (!permissions?.includes('canViewOrders') && childMenu.id === 'orders') {
                return false;
              }
              if (user?.userType !== 'ADMIN' && childMenu.id === 'roles') {
                return false;
              }
              if (user?.userType !== 'ADMIN' && childMenu.id === 'admin-logs') {
                return false;
              }
              return true;
            })
          }))
          ?.filter((parentMenu) => {
            if (parentMenu.id === 'group-stocks') {
              return permissions?.includes('canViewStocks');
            }
            return true;
          }) || []
      );
    };

    // Check permissions for ADMIN and non-ADMIN users
    if (user?.userType === 'ADMIN') {
      setMenuItems(menuItemsToDisplay || { items: [] });
    } else {
      setMenuItems({ items: filterMenuItems() });
    }
  }, [menuItem, isAdvanced, user, permissions]);

  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  const lastItem = isHorizontal ? HORIZONTAL_MAX_ITEM : null;
  let lastItemIndex = menuItems.items?.length ? menuItems.items.length - 1 : 0;
  let remItems: NavItemType[] = [];
  let lastItemId = '';

  if (lastItem && menuItems.items?.length && lastItem < menuItems.items.length) {
    lastItemId = menuItems.items[lastItem - 1]?.id || '';
    remItems =
      menuItems.items?.slice(lastItem - 1, menuItems.items.length)?.map((item) => ({
        title: item.title,
        elements: item.children,
        icon: item.icon
      })) || [];
  }

  const navGroups =
    menuItems.items?.slice(0, lastItemIndex + 1)?.map((item) => {
      switch (item.type) {
        case 'group':
        case 'collapse':
          return (
            <NavGroup
              key={item.id}
              setSelectedItems={setSelectedItems}
              setSelectedLevel={setSelectedLevel}
              selectedLevel={selectedLevel}
              selectedItems={selectedItems}
              lastItem={lastItem!}
              remItems={remItems}
              lastItemId={lastItemId}
              item={item}
            />
          );
        default:
          return (
            <Typography key={item.id} variant="h6" color="error" align="center">
              Fix - Navigation Group
            </Typography>
          );
      }
    }) || [];

  return (
    <Box
      sx={{
        pt: drawerOpen ? (isHorizontal ? 0 : 2) : 0,
        '& > ul:first-of-type': { mt: 0 },
        display: isHorizontal ? { xs: 'block', lg: 'flex' } : 'block'
      }}
    >
      {navGroups}
    </Box>
  );
};

export default Navigation;
